import { useMemo } from "react";
import { useDevices } from "@/features/devices/hooks";
import { useSensors } from "@/features/sensors/hooks";
import type { SensorsByCardId } from "@/types/device-manager.types";

// Carrega CLPs (lista) + sensores (lista global) e agrupa sensores por cartão.
// Os CARTÕES carregam preguiçosamente por nó (useCards) dentro de cada ramo da
// árvore — ver research.md R6 (carga preguiçosa, sem virtualização no volume-alvo).
export function useDeviceTree() {
  const devices = useDevices();
  const sensors = useSensors();

  const sensorsByCardId: SensorsByCardId = useMemo(() => {
    const map: SensorsByCardId = new Map();
    for (const s of sensors.data ?? []) {
      if (!s.cardId) continue;
      const arr = map.get(s.cardId);
      if (arr) arr.push(s);
      else map.set(s.cardId, [s]);
    }
    return map;
  }, [sensors.data]);

  // Contagem de sensores por código de CLP (device codes são únicos por org),
  // para a árvore mostrar o total mesmo com o CLP recolhido.
  const sensorCountByDeviceCode = useMemo(() => {
    const map = new Map<string, number>();
    for (const s of sensors.data ?? []) {
      const code = s.card?.device.code;
      if (!code) continue;
      map.set(code, (map.get(code) ?? 0) + 1);
    }
    return map;
  }, [sensors.data]);

  return {
    devices: devices.data ?? [],
    sensorsByCardId,
    sensorCountByDeviceCode,
    isLoading: devices.isLoading || sensors.isLoading,
    isError: devices.isError || sensors.isError,
  };
}
